export const SUMMARY_ATTEMPT = "SUMMARY_ATTEMPT";
export const SUMMARY__SUCCESS = "SUMMARY__SUCCESS";
export const SUMMARY_FAILED = "SUMMARY_FAILED";
export const LOGOUT = "LOGOUT";